"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../Pages/Dashboard/Types");
var endpoints_1 = require("./endpoints");
var Util_1 = require("./Util");
var AuthenticationService_1 = require("./AuthenticationService");
var GetMultiPackRequestEndpoint = function (selectedAction) {
    var endpoint = "" + endpoints_1.default.Packs.Api.MultiPackReqeust;
    if (selectedAction.value != Types_1.PackAction.Verify.value) {
        endpoint += "?packState=" + Types_1.PackState.parse(selectedAction.value).value;
    }
    return endpoint;
};
var MultiplePackRequestService = /** @class */ (function () {
    function MultiplePackRequestService() {
    }
    MultiplePackRequestService.SubmitPackRequest = function (packIdentifiers, selectedAction, selectedLocation) {
        var body = JSON.stringify(packIdentifiers);
        var endpoint = GetMultiPackRequestEndpoint(selectedAction);
        return new Promise(function (resolve, reject) {
            Util_1.postJson(endpoint, body, undefined, undefined, new Util_1.UserRequestHeaders({ Organisation: AuthenticationService_1.Auth.getUser().Organisation, Location: selectedLocation, UserId: AuthenticationService_1.Auth.getUser().id }))
                .then(function (result) {
                if (result != null) {
                    var response = JSON.parse(result);
                    //if (response.packInfo.Uprc) {
                    //    EventHandlerProvider.GetInstance().AddEvent(UprcWarningEvent(resources, response.packInfo.Uprc));
                    //}
                    resolve(response);
                    //this.setState({
                    //    result: response,
                    //    currentState: SafePageState.Result,
                    //    availableActions: response.packActions
                    //});
                }
                else {
                    reject("No Response");
                    //this.setState({
                    //    currentState: SafePageState.Error,
                    //    availableActions: []
                    //});
                }
            })
                .catch(function (err) {
                return reject(err);
            });
        });
    };
    return MultiplePackRequestService;
}());
exports.MultiplePackRequestService = MultiplePackRequestService;
//# sourceMappingURL=MultiplePackRequestService.js.map